import { CHART_COLORS, CHART_FONT_FAMILY } from './chartTheme'

const escapeHtml = (value: string | number | undefined | null): string => {
  if (value == null) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export interface ChartTooltipItem {
  label?: string
  value?: string | number
  color?: string
  image?: string
}

export const buildChartTooltipHtml = (
  header: { label?: string, value?: string },
  list: ChartTooltipItem[]
): string => {
  const items = (list || []).map((item) => {
    const colorDot = item.color
      ? `<span style="width:10px;height:10px;min-width:10px;border-radius:50%;background:${escapeHtml(item.color)};display:inline-block;"></span>`
      : ''
    const image = item.image
      ? `<img src="${escapeHtml(item.image)}" width="30" height="30" style="margin-left:${item.color ? 10 : 0}px;border:1px solid #ededee;object-fit:cover;" />`
      : ''
    return `
      <div style="display:flex;align-items:center;justify-content:space-between;height:40px;gap:12px;">
        <div style="display:flex;align-items:center;min-width:0;">
          ${colorDot}
          ${image}
          <span style="color:${CHART_COLORS.white};font-weight:bold;margin-left:${(item.color || item.image) ? 10 : 0}px;white-space:nowrap;">
            ${escapeHtml(item.label)}
          </span>
        </div>
        <span style="color:${CHART_COLORS.white};font-weight:bold;margin-left:60px;white-space:nowrap;">
          ${escapeHtml(item.value)}
        </span>
      </div>
    `
  }).join('')

  return `
    <div style="font-family:${CHART_FONT_FAMILY};font-size:14px;min-width:180px;">
      <div style="display:flex;align-items:center;justify-content:space-between;">
        <span style="color:${CHART_COLORS.white};">${escapeHtml(header.label)}</span>
        <span style="color:${CHART_COLORS.white};margin-left:60px;">${escapeHtml(header.value)}</span>
      </div>
      <div style="margin-top:10px;height:1px;background:${CHART_COLORS.secondaryContent};"></div>
      ${items}
    </div>
  `
}

export const chartTooltipBase = {
  backgroundColor: CHART_COLORS.tooltipBackground,
  borderWidth: 0,
  padding: 12,
  extraCssText: 'box-shadow:none;border-radius:2px;'
}
